

import { signalGenericRequest } from "../../../api/signalApi";
import { ACCOUNT_ENTRIES_COMPANIES, ACCOUNT_ENTRIES_PERIODS, ACCOUNT_ENTRIES_SCHEME, ACCOUNT_ENTRIES_VFLEX_CONFIGURATION } from "../../../constants/signalRequestConsts";
import { store } from "../../store";


// ACCOUNT_ENTRIES_SCHEME
// ACCOUNT_ENTRIES_PERIODS
// ACCOUNT_ENTRIES_VFLEX_CONFIGURATION


export const getCompanies = async () => {
    const {sessionData} = store.getState().auth;
	// const headers = {
	// 	ModuleId: process.env.REACT_APP_MODULE_ID,
	// 	Token: authCompanySelectedState.companyselected?.Token,

	// }
    await signalGenericRequest(
        ACCOUNT_ENTRIES_COMPANIES,
        `dbo.S10_14_Empresa_ListarPorUsuario '${sessionData?.UserName}','14','1'`
    )
}

export const getSchemes = async (companyRuc: string) => {
    await signalGenericRequest(
        ACCOUNT_ENTRIES_SCHEME,
        `dbo.S10_14_Esquema_ListarPorEmpresa '${companyRuc}'`
    )
}

export const getPeriods = async (companyRuc: string) => {
    await signalGenericRequest(
        ACCOUNT_ENTRIES_PERIODS,
        `dbo.S10_14_Periodo_ListarPorEmpresa '${companyRuc}'`
    )
}


export const getConfiguration = async () => {
    const {sessionData} = store.getState().auth;
    await signalGenericRequest(
        ACCOUNT_ENTRIES_VFLEX_CONFIGURATION,
        `dbo.sp_ConfiguracionVsFlex '${sessionData?.UserName}', 'LibroDiarioEscenario', 0, 0, ''`
    )
}
